import { render, staticRenderFns } from "./OsQuestionnairesOverview.vue?vue&type=template&id=1788ef0d&scoped=true"
import script from "./OsQuestionnairesOverview.vue?vue&type=script&lang=ts"
export * from "./OsQuestionnairesOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1788ef0d",
  null
  
)

export default component.exports